export const ADD_PLATE = 'ADD_PLATE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_LOADING = 'UPDATE_PROFILE_LOADING';
export const GET_PROFILE = 'GET_PROFILE';
export const ADD_ORDER = 'ADD_ORDER';
export const ADD_REVIEW = 'ADD_REVIEW';
export const ORDER_LOADING = 'ORDER_LOADING';
export const REVIEW_LOADING = 'REVIEW_LOADING';
export const ORDER_ERROR = 'ORDER_ERROR';
export const GET_ORDERS = 'GET_ORDERS';
export const PLATE_QNT_UP = 'PLATE_QNT_UP';
export const FORMULE_QNT_UP = 'FORMULE_QNT_UP';
export const PLATE_QNT_DOWN = 'PLATE_QNT_DOWN';
export const FORMULE_QNT_DOWN = 'FORMULE_QNT_DOWN';
export const ADD_FORMULE = 'ADD_FORMULE';
export const CLEAR_CART = 'CLEAR_CART';
export const REMOVE_PLATE = 'REMOVE_PLATE';
export const REMOVE_FORMULE = 'REMOVE_FORMULE';
export const GET_POSTS = 'GET_POSTS';
export const GET_FILTERS = 'GET_FILTERS';
export const GET_FAVORIES = 'GET_FAVORIES';
export const GET_RESTAURANTS = 'GET_RESTAURANTS';
export const GET_RESTAURANT = 'GET_RESTAURANT';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const REST_LOADING = 'REST_LOADING';
export const DELETE_FAVORY = 'DELETE_FAVORY';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const GET_LOCATION = 'GET_LOCATION';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR';
export const ADD_FAVORY = 'ADD_FAVORY';
export const ALGO_SEARCH = 'ALGO_SEARCH';
export const ALGO_CLEAR = 'ALGO_CLEAR';
export const SET_ORDER_JOUR = 'SET_ORDER_JOUR';
export const SET_ORDER_HOUR = 'SET_ORDER_HOUR';
export const SET_ORDER_ID = 'SET_ORDER_ID';
export const REMOVE_ORDER_TIME = 'REMOVE_ORDER_TIME';
export const UPDATE_PASSWORD_LOADING = 'UPDATE_PASSWORD_LOADING';
